import { createFileRoute } from '@tanstack/react-router'
import TermsRuleErrorReportList from 'Royalty/components/Reports/ErrorReport/TermsRuleErrorReportList'

export const Route = createFileRoute('/royalty/errorlist/terms')({
    component: TermsRuleErrorReportList,
})
